import axiosInstance from '../../api/axios.js';
import type { CreateUserRequest } from '../../admin/types.ts';
import type { RbacRole } from '../../admin/api/rbac.api.ts';

export async function fetchOrgAdminRoles(): Promise<RbacRole[]> {
  const { data } = await axiosInstance.get('/api/org-admin/roles');
  return (data?.roles as RbacRole[]) ?? [];
}

export async function createOrgMemberUser(payload: CreateUserRequest): Promise<void> {
  await axiosInstance.post('/api/org-admin/users', {
    username: payload.username,
    email: payload.email,
    first_name: payload.first_name,
    last_name: payload.last_name,
    password: payload.password,
    role: payload.role,
  });
}
